import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment';

export const MY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-ui-monthpicker',
  templateUrl: './ui-monthpicker.component.html',
  styleUrls: ['./ui-monthpicker.component.scss'],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useFactory: () => {
        return MY_FORMATS;
      },
    },
  ],
  standalone: false,
})
export class UiMonthpickerComponent {
  @Input() control: FormControl<Date | null>;

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = new Date();
    ctrlValue.setMonth(normalizedMonthAndYear.month());
    ctrlValue.setFullYear(normalizedMonthAndYear.year());
    this.control.setValue(ctrlValue);
    datepicker.close();
  }
}
